<template>
  <v-chip class="mr-2" x-small :color="chipsColor" :text-color="textColor">
      {{ formattedChipText }}
  </v-chip>
</template>

<script>
export default {
  name: 'Chip',
  props: {
      chipText: {
          type: [String, Number, Object], 
          default: 'Chips'
      },
      chipsColor: {
          type: String,
          default: 'black'
      },
      textColor: {
          type: String,
          default: 'white'
      }
  },
  computed: {
      formattedChipText() {
          if (typeof this.chipText === 'object') {
              return JSON.stringify(this.chipText);
          }
          return this.chipText.toString();
      }
  }
};
</script>

<style scoped></style>